import { defaultTheme } from '../styles/theme/default';
import {
  Colors,
  ColorTokenType,
  ColorWeightType,
  PrimitiveColorsType,
  SimpleColorType,
} from '../interfaces/colors';

export const getColorHelper = (
  fillColor: PrimitiveColorsType | Colors | string,
  colorWeight?: ColorWeightType | SimpleColorType
) => {
  if (colorWeight) {
    const colorPalette = defaultTheme.colors[fillColor as PrimitiveColorsType];
    if (colorPalette && colorPalette[colorWeight]) {
      return colorPalette[colorWeight];
    }

    return defaultTheme.colors.simple.black;
  }

  return (
    defaultTheme.colorToken[fillColor as ColorTokenType] ||
    fillColor ||
    defaultTheme.colors.simple.black
  );
};
